import { useMemo, useCallback } from 'react'
import { useWidgetContext } from '@dxp-module/common'
import { tokenService } from '@dxp-module/login'
import type { DropdownOption } from '../model/DropdownOption'
import ROUTES from '../../common/enum/Routes'

type UseDropdownOptionsReturnProps = {
  defaultOptionList: DropdownOption[]
  handleAction: (key: string) => void
}

const useDropdownOptions = (): UseDropdownOptionsReturnProps => {
  const {
    configuration: { myAccountUrl: myAccountUrlContext },
  } = useWidgetContext()
  const myAccountUrl = myAccountUrlContext?.endsWith('/')
    ? myAccountUrlContext.slice(0, -1)
    : myAccountUrlContext

  const handleManageDetailsRedirect = useCallback(() => {
    window.location.href = `${myAccountUrl || ''}${
      ROUTES.MYACCOUNT_PERSONAL_DETAILS
    }`
  }, [myAccountUrl])

  const handleSignOut = useCallback(() => {
    tokenService.removeCurrentToken()

    if (window.location.href.includes(myAccountUrl || '')) {
      window.location.href = myAccountUrl || ''
    }
  }, [myAccountUrl, window.location.href])

  const handleSignIn = useCallback(() => {
    window.location.href = myAccountUrl || ''
  }, [myAccountUrl, window.location.href])

  const handleManageOrdersRedirect = useCallback(() => {
    window.location.href = `${myAccountUrl || ''}${ROUTES.MYACCOUNT_ENQUIRY}`
  }, [myAccountUrl])

  const handleAction = (key: string) => {
    switch (key) {
      case 'sign_in':
        return handleSignIn()
      case 'sign_out':
        return handleSignOut()
      case 'open_details':
        return handleManageDetailsRedirect()
      case 'open_orders':
        return handleManageOrdersRedirect()
      default:
        break
    }
  }

  const defaultOptionList: DropdownOption[] = useMemo(
    () => [
      {
        label: 'trans__myaccount__mini_widget__manage_details_cta',
        key: 'open_details',
        iconName: 'ManageAccounts',
      },
      {
        label: 'trans__myaccount__mini_widget__sign_out_cta',
        key: 'sign_out',
        iconName: 'Logout',
      },
    ],
    []
  )

  return { handleAction, defaultOptionList }
}

export default useDropdownOptions
